import * as Yup from "yup";
import { getInitialValues } from "layouts/views/common/common";

const formField = {
  divisionGroup: {
    name: "divisionGroup",
    label: "Division Group",
    type: "text",
    errorMsg: "Division Group is Required.",
    required: true,
  },
  divisionDesc1: {
    name: "divisionDesc1",
    label: "Description",
    type: "text",
    errorMsg: "Description is Required.",
    required: true,
  },
  customerCode: {
    name: "customerCode",
    label: "Customer Code",
    type: "select",
    errorMsg: "Customer Code is Required.",
    required: true,
  },
  shortName: {
    name: "shortName",
    label: "Short Name",
    type: "text",
  },
};

const { divisionGroup, divisionDesc1, customerCode, shortName } = formField;

export const formRender = [
  [divisionGroup],
  [divisionDesc1],
  [customerCode],
  // [shortName]
];

export const initialValues = getInitialValues(formField);

export const divisionValidation = Yup.object().shape({
  [divisionGroup.name]: Yup.string().nullable().required(divisionGroup.errorMsg),
  [divisionDesc1.name]: Yup.string().nullable().required(divisionDesc1.errorMsg),
  customerCode: Yup.array().of(Yup.string()).min(1, "At Least One CustomerCode Required"),
  [shortName.name]: Yup.string().nullable(),
});